module.exports = __webpack_public_path__ + "static/media/kudos-celebration-icon.589981d6.svg";